import moment from 'moment/moment';
import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { salesforceSendFormNumber, savePaymentDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';


const ChecqueForm = ({selectedInstFeeDetail,feeDetail,userDetail}) => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [checqueNumber, setChecqueNumber] = useState({ value: '', error: '' });
  const [transactionDate, setTransactionDate] = useState({ value: '', error: '' });
  const [transactionType, setTransactionType] = useState({ value: '', error: '' });
  const [receipt,setReceipt] = useState({name:'',value: "",id:'',error: ""});

  const currentDate = moment().format('YYYY-MM-DD');
  const minDate = moment(currentDate).subtract(7, 'days').format('YYYY-MM-DD');
  const {id,form_num} = userDetail !==undefined && userDetail
  const {installment_type,net_payable_amount,scholarship_amount,scholarship_percentage,total_fee} = feeDetail !==undefined && feeDetail


  const validation = () => {
    let formIsValid = true
    // Student Name

    if (!checqueNumber.value) {
        formIsValid = false
        let msg = "Please enter Cheque number"
        setChecqueNumber({ ...checqueNumber, error: msg })
    }
    if (!transactionDate.value) {
        formIsValid = false
        let msg = "Please select date"
        setTransactionDate({ ...transactionDate, error: msg })
    }
    if (!receipt.value) {
        formIsValid = false
        let msg = "Please please upload receipt"
        setReceipt({ ...receipt, error: msg })
    }
   
    if (formIsValid) {
        setChecqueNumber({ ...checqueNumber, error: '' })
        setTransactionDate({ ...transactionDate, error: '' })
        setReceipt({ ...receipt, error: '' })

    }
    return formIsValid;
}

const handleReceiptChange=(e)=>{
    let receiptName=e.target.name
    const value=e.target.files
    setReceipt({...receipt,name:receiptName,value:value[0],error:''})
}

const onSubmit = async (e) => {

  e.preventDefault(); 
  if (validation()) {
  const formDataToSend = new FormData();
  formDataToSend.append('student_id', id);
  formDataToSend.append('amount', selectedInstFeeDetail?.amount);
  formDataToSend.append('pay_transaction_id',checqueNumber.value)
  formDataToSend.append('cheque_number',checqueNumber.value)
  formDataToSend.append('transaction_date',currentDate)
  formDataToSend.append('cheque_date',transactionDate.value)

  formDataToSend.append('transaction_receipt',receipt.value);
  formDataToSend.append('payment_mode','offline');
  formDataToSend.append('payment_type',2);
  formDataToSend.append('installments_id',selectedInstFeeDetail?.installment_id);
  formDataToSend.append('installment_type',selectedInstFeeDetail?.installment_number ==0? 'lumpsum': installment_type);
  formDataToSend.append('installments_number',selectedInstFeeDetail?.installment_number);
  formDataToSend.append('scholarship_amount',scholarship_amount);
  formDataToSend.append('net_payable_amount',net_payable_amount);
  formDataToSend.append('scholarship_percentage',scholarship_percentage);
  formDataToSend.append('actual_inst_amt',selectedInstFeeDetail?.amount);
  formDataToSend.append('course_fee',total_fee);

  setLoading(true)

    try {
    await savePaymentDetail(formDataToSend).then((res) => {
        
        if(res.status){
            setLoading(false)
            salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
            swal(res.message,'','success')
            navigate('/student/dashboard');
        }
        else{
            setLoading(false)
            swal(res.message,'Try Again!','error')
        }
    })
    } catch (error) {
        console.log('offline error..',error)
    }

}

}
  return (
    <form onSubmit={onSubmit} className="hold_mandatoryField">

            <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                          <label className="form-label">Amount</label>
                          <input type="text" disabled className="form-control"  value={selectedInstFeeDetail?.amount} placeholder="Enter Amount"
                            onChange={(e) => {}}
                            name="amount" />
                    {/* {amount.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{amount.error}</div>} */}
                </div>

                <div className="col-lg-6 mb-3">
                        <label className='form-label'>Cheque Number <span>*</span></label>
                        <input type="text"  className="form-control" value={checqueNumber.value} placeholder="Enter cheque number"
                            onChange={(e) => {setChecqueNumber({ ...checqueNumber, value: e.target.value, error: '' });}}
                            name="checqueNumber" />
                    {checqueNumber.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{checqueNumber.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                      <label className='form-label' htmlFor="floatingInput">Cheque Date <span>*</span></label>
                        <input type="date" className="form-control" min={minDate} max={currentDate} placeholder="Enter"
                            value={transactionDate.value}
                            onChange={(e) => {setTransactionDate({ ...transactionDate, value: e.target.value, error: '' });}}
                            name="trxn_date" />
                        {transactionDate.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{transactionDate.error}</div>}
                </div>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="formFile" className="form-label">Upload Receipt <span>*</span></label>
                    <input className="form-control" type="file" name={receipt.name} 
                    accept="image/png, image/gif, image/jpeg, docx, doc, pdf" 
                    onChange={(e) => handleReceiptChange(e)}/>
                  {receipt.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{receipt.error}</div>}
                </div>
                
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6  d-flex align-items-center  col-sm-6 col-6 mb-3">
                {loading ? (<button type="submit" disabled className="btn btn-primary">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Sending ...</button>) : 
                    <button type="submit" className="btn btn-primary">Submit</button>
                }
                    <Link to="/student/dashboard" className="btn btn-default ms-2 ms-lg-2">Cancel</Link>
                </div>

            </div>
        </form>
  )
}

export default ChecqueForm